import { ColumnDef } from "@tanstack/react-table"
import moment from "moment"
import React from "react"
import { FormattedDate } from "react-intl"
import { DateColumnDefinition, TableRowData } from "../../../../../../state/listing/generic-listing/column-definitions"

export default (columnDefinition: DateColumnDefinition): Partial<ColumnDef<TableRowData>> => ({
    cell: info => {
        const isLate = (): boolean => {
            const now = moment().startOf("day").toDate()
            const dueDate = new Date(info.getValue() as string)
            return (columnDefinition.dataAttributes?.dateExpiryStatuses ?? []).includes(info.row.original.status) && now > dueDate
        }
        
        return info.getValue() ? (
            <span className={isLate() ? "text-danger" : ""}>
                <FormattedDate
                    year='numeric'
                    month='long'
                    day='numeric'
                    value={new Date(info.getValue() as string)}
                />
            </span>
        ) : (
            columnDefinition.dataAttributes?.defaultValue || "-"
        )
    }
})


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/listing-table/mappers/cell-mappers/DateCellMapper.tsx